module.exports = __webpack_public_path__ + "img/horizontal_6_4_pp1_7005.095d7b67.png";